export default "__VITE_ASSET__BW1q69Mk__"